import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import SimpleModal from './SimpleModal';

const TITLE = 'Saved Searches';
const MODEL_TYPE = 'saved search';
const DEFAULT_URL = '/newsroom/';
const BASE_URL = DEFAULT_URL;

const SavedSearchModal = ({
  params = [],
  newSavedSearch = noop,
  ...props
}) => {
  const modelId = params[0] === 'newsroom' && params[1];
  const getCollection = () => Account.get('saved_searches') || [];
  return (<SimpleModal
    title={TITLE}
    modelType={MODEL_TYPE}
    baseUrl={BASE_URL}
    defaultUrl={DEFAULT_URL}
    modelId={modelId}
    getCollection={getCollection}
    newItem={newSavedSearch}
    {...props}
  />);
};

SavedSearchModal.propTypes = {
  params: PropTypes.array,
  newSavedSearch: PropTypes.func
};

export default SavedSearchModal;
